import React, {useEffect, useLayoutEffect} from 'react'
import Color from '../Components/Colors/Color'
import Header from '../Models/HeaderContainer'
import '../Styles/ServicePage.css'
import { useStateContext } from '../Contexts/productsCardContext'

const Service = () => {

    const {setPage} = useStateContext();

    useEffect(() => {
        setPage('other');
        
        window.scrollTo(0,0);
      }, [])

    return (
        <div className='service-page-container' style={{backgroundColor: Color.primaryBackground, color: Color.secondaryText}}>
            <Header name='Services' />

            <div className='service-page-content-container'>
                <div className='service-page-sales-container'>
                    <h3 className='service-page-sales-header'>
                        Sales And After Sales
                    </h3>
                    <p className='service-page-sales-content'>
                        There seems to be a lot of confusion around what a PABX is, what a PBX is and the difference between the two. 
                        Well there is no difference. A PABX is a Private Automatic Branch Exchange and a PBX is a Private Business eXchange. 
                        Both serve the same purpose and that is as a telephone system for a business. If your business is looking for a telephone 
                        system that is owned by the business as opposed to by a telephone company, then you are looking for a PABX system, although 
                        in most recent years these are often referred to as PBX Systems.
                    </p>

                    <p className='service-page-sales-content'>
                        A PABX will connect the businesses instruments separately to the public telephone network (PSTN) A PABX system makes sure that every 
                        internal call made is routed through the PABX.
                    </p>
                    <ul className='service-page-sales-list'>
                        <li className='service-page-sales-item'>
                            Requirement Analysis
                        </li>
                        <li className='service-page-sales-item'>
                            Cost effective selection
                        </li>
                        <li className='service-page-sales-item'>
                            Delivery and Installation
                        </li>
                    </ul>
                    <div className='service-page-img-container'>
                        <img src='/Images/service_img.jpg' alt='service image' className='service-page-img' /> 
                    </div>
                </div>

                <div className='service-page-maintainance-container'>
                    <h3 className='service-page-maintainance-header'>
                        Maintenance
                    </h3>
                    <p className='service-page-maintainance-content'>
                        We do functional checks, servicing, repairing or replacing necessary parts, and supporting utilities in industrial, business, 
                        governmental, and residential installations. We do cost-effective practices to keep equipment operational; 
                        these activities take place either before or after a failure.
                    </p>
                    <ul className='service-page-maintainance-list'>
                        <li className='service-page-maintainance-item'>
                            Functional Checks
                        </li>
                        <li className='service-page-maintainance-item'>
                            Servicing
                        </li>
                        <li className='service-page-maintainance-item'>
                            Repairing or replacing necessary parts
                        </li>
                        <li className='service-page-maintainance-item'>
                            Installation and configuring
                        </li>
                    </ul>
                    <div className='service-page-img-container'>
                        <img src='/Images/maintenance.jpg' alt='maintainance image' className='service-page-img' /> 
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Service;